// Shared helpers for the PRE-LOGIN screens that an emailed Owner Account link lands on.
//
// PH-68 (password reset) landed first and therefore owns this file; PH-69 (the email-confirmation
// landing page) reuses it rather than writing a second copy — recorded on both cards.
//
// Both links are built server-side by `app/routers/account_auth.py` as a QUERY STRING:
// `_reset_link()` returns `{PUBLIC_APP_URL}/account/reset-password?token={token}`. There is no
// hash variant of either link, so nothing here reads `window.location.hash`. Do NOT copy
// `SetupWizard.jsx`'s hash-first order into these screens — that order exists for the setup-invite
// link, which genuinely has both shapes, and applying it here would just read a hash that is
// never set.

export const ACCOUNT_RESET_PASSWORD_PATH = '/account/reset-password';

// A trailing slash is tolerated; nothing else is. Deliberately an exact match rather than a prefix
// test, so `/account/reset-password-anything` never renders one of these screens.
export function isPath(route, pathname) {
  const p = String((pathname === undefined ? window.location.pathname : pathname) || '');
  return p === route || p === `${route}/`;
}

// The token exactly as it arrived, or '' when there is none.
//
// Never throws: a URL the platform refuses to parse is the same as "no token" to every caller, and
// every caller already has to handle the tokenless case anyway — `scrubLinkToken()` below makes a
// refresh tokenless by design.
export function readLinkToken(search) {
  try {
    const s = search === undefined ? window.location.search : search;
    return new URLSearchParams(s || '').get('token') || '';
  } catch (_) {
    return '';
  }
}

// Take the token out of the address bar, so it never reaches browser history, a bookmark, a URL
// the owner pastes to someone else, or a screenshot of the address bar (AGENTS.md §6).
//
// MUST be called from an EFFECT, never from a `useState` initializer. `index.js` renders the app
// under `React.StrictMode`, which double-invokes every render body: a scrub inside an initializer
// lets the second pass read an already-stripped URL and capture an empty token — the screen would
// then report "this link is incomplete" for a link that was perfectly good. `replaceState` is
// idempotent, so running it twice from an effect is harmless. `SetupWizard.jsx:13-22` puts this
// exact side effect inside its initializer; mirror its intent, not its shape.
export function scrubLinkToken() {
  try {
    window.history.replaceState(null, '', window.location.pathname);
  } catch (_) { /* a browser that refuses replaceState simply keeps the URL it already had */ }
}
